import React, { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";

import { useTranslation } from "react-i18next";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import moment from "moment";

import Swal from "sweetalert2";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import OrgContext from "../organisation/OrgContext";
import jwtInterceoptor from "../components/shared/jwtInterceptor";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { baseURL } from "../services/api";
import { useNavigate } from "react-router-dom";
import { frFR, enUS } from "@mui/x-data-grid";
import { formatNumber, isNumeric } from "../helpers/formater";
import { LinearProgress } from "@mui/material";
import useAuthHelper from "../helpers/AuthHelper";
import Papa from "papaparse";
import logo from "../assets/images/ElmanagerLogo.png";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          x
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

function Tresorie(props) {
  const [t, i18n] = useTranslation();
  const navigate = useNavigate();

  const { organisation } = useContext(OrgContext);

  const [depenseInvoices, setDepenseInvoices] = useState([]);
  const [achatInvocies, setAchatInvocies] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [staticInvoices, setStaticInvoices] = useState([]);

  const [status, setSatus] = useState([]);

  const [currentSelectedStatus, setCurrentSelectedStatus] = useState(0);
  const [newStatus, setNewStatus] = useState(0);
  const [currentSelectedInvoice, setCurrentSelectedInvoice] = useState(0);
  const [paymentType, setPaymentType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [invoiceType, setInvoiceType] = useState("");
  const [bqAccountId, setBqAccountId] = useState("b");
  const [banqueAccounts, setBanqueAccounts] = useState([]);
  const [caisseAccountId, setCaisseAccountId] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  const [grandTotal, setGrandTotal] = useState(null);
  const [totalRestPaye, setTotalRestPaye] = useState(null);
  //filtre de date
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [filteredInvoices, setFilteredInvoices] = useState(invoices);
  // visible columns
  const [visibleColumns, setVisibleColumns] = useState({
    __check__: true,
    "Numéro de facture": true,
    Client: true,
    "Date de Facture": true,
    "Montant ttc": true,
    "Montant payé": true,
    "Reste à payé": true,
    status: true,
    "Dernier date de paiement": true,
    Action: true,
  });
  //store the visible columns
  const { onlyCommercial } = useAuthHelper();

  useEffect(() => {
    onlyCommercial();

    const storedColumns = JSON.parse(
      localStorage.getItem("visibleColumnstrésorerie")
    );
    if (storedColumns) {
      setVisibleColumns(storedColumns);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "visibleColumnstrésorerie",
      JSON.stringify(visibleColumns)
    );
  }, [visibleColumns]);

  const handleColumnVisibilityModelChange = (newModel) => {
    if (Object.keys(newModel).length === 0) {
      console.log(",,,,,,,,,,,,", newModel);
      newModel = {
        __check__: true,
        "Numéro de facture": true,
        Client: true,
        "Date de Facture": true,
        "Montant ttc": true,
        "Montant payé": true,
        "Reste à payé": true,
        status: true,
        "Dernier date de paiement": true,
        Action: true,
      };
    }
    if (newModel) {
      console.log(visibleColumns);
      const updatedVisibleColumns = { ...visibleColumns, ...newModel };

      setVisibleColumns(updatedVisibleColumns);
      console.log("visible colonne state: ", updatedVisibleColumns);
    } else {
      console.error("newModel is undefined");
    }
  };

  // Fonction pour gérer le filtrage a partir de la date
  const handleFilterDate = () => {
    let startDate = moment(dateDebut, "YYYY-MM-DD").startOf("day");
    let endDate = dateFin
      ? moment(dateFin, "YYYY-MM-DD").endOf("day")
      : moment().endOf("day");

    // Check if start date is after end date
    if (startDate.isAfter(endDate)) {
      toast.warning(
        t("La date de début ne peut pas être supérieure à la date de fin."),
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
      return; // Stop further execution if dates are invalid
    }

    if (dateDebut && (dateFin || endDate)) {
      console.log(invoices);

      // Filter invoices based on payment dates
      const filteredData = invoices.filter((invoice) => {
        if (invoice.status !== 1) {
          return invoice.payment.some((datep) => {
            const invoiceDate = moment(datep.created_at, "YYYY-MM-DD").startOf(
              "day"
            );
            console.log("Dernier date de paiement :", datep.created_at);

            if (endDate) {
              return invoiceDate.isBetween(startDate, endDate, null, "[]");
            } else {
              return invoiceDate.isSameOrAfter(startDate);
            }
          });
        }
      });

      console.log("Filtered Data:", filteredData);

      // Show warning if no invoices match the filter
      if (filteredData.length === 0) {
        toast.warning(t("Aucune facture trouvée entre ces dates."), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }

      // Update filtered invoices state
      setFilteredInvoices(filteredData);
      console.log("Filtered Invoices:", filteredData); // Log after setting the data
    } else {
      toast.error(t("Veuillez sélectionner les dates de début et de fin."), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    $(".some-fields-are-required-to-save").css("display", "none");
    if (organisation.id) {
      window.$("#staticBackdrop").modal("show");
      fetchStatusInvoices();
      getAllInvoices();
      getAccounts();
    }
  }, []);

  const getAccounts = async () => {
    await axios
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        setBanqueAccounts(response.data.data);
        response.data.data.map((a) => {
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.id);
            console.log("banque", a.id);
          } else if (a.name === "Caisses") {
            setCaisseAccountId(a.id);
            console.log("caisse", a.id);
          }
        });
      })
      .catch((error) =>
        console.log("error while retrieving getAccounts : " + error)
      );
  };
 

  const getAllInvoices = async () => {
  setLoadingData(true);

  const response = await jwtInterceoptor.get(
    `/data/user/factures/getallinvocies/${organisation.id}`
  );

  if (response.status === 200) {
    setInvoices(response.data.data);
    setStaticInvoices(response.data.data);

    console.log("invodsdsdcies: ", response.data.data);

    console.log(
      "PAYMENTS INVALIDES:",
      response.data.data
        .filter((invoice) => {
          const lastPayment =
            invoice.payment?.[invoice.payment.length - 1];

          return !lastPayment || !lastPayment.status;
        })
        .map((invoice) => ({
          id: invoice.id,
          invoice_number: invoice.invoice_number,
          payment: invoice.payment,
          lastPayment: invoice.payment?.[invoice.payment.length - 1],
        }))
    );
  }

  setLoadingData(false);
};
  const fetchStatusInvoices = async () => {
    const response = await jwtInterceoptor.get(`/data/user/status/factures`);

    if (response.status === 200) {
      setSatus(response.data.data);
      console.log(response.data.data);
    }
  };

  const deleteItem = async (inv) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await jwtInterceoptor.delete(
          `/data/user/factures/delete/${inv.id}`
        );

        if (response.status === 200) {
          if (response.data.status == true) {
            let invs = invoices.filter((el) => el.id != inv.id);

            setInvoices(invs);

            Swal.fire(
              t("Deleted!"),
              t("Your record has been deleted."),
              "success"
            );

            return;
          }
        }

        Swal.fire({
          icon: "warning",
          title: "",
          text: t("Something went wrong!, try again"),
        });
      }
    });
  };

  const getMantantPaye = (payment) => {
    let mp = 0;
    for (let i = 0; i < payment.length; i++) {
      mp += parseFloat(payment[i].payed_amount);
    }
    return mp;
  };

  const columns = [
    {
      field: "Numéro de facture",
      headerName: t("Numéro de facture"),
      valueGetter: (params) =>
        isNumeric(params.row.invoice_number)
          ? `FACT-${params.row.type.toUpperCase()}-${formatNumber(
              params.row.invoice_number
            )}`
          : params.row.invoice_number,
      width: 180,
    },
    {
      flex: 1,
      field: "Client",
      headerName: t("Client/Fournisseur"),
      valueGetter: (params) => params.row.client.companyName,
    },
    {
      flex: 1,
      field: "Date de Facture",
      headerName: t("Date de Facture"),
      valueGetter: (params) =>
        `${moment(params.row.created_at).format("DD/MM/YYYY") || ""}`,
    },
    {
      flex: 1,
      field: "Montant ttc",
      headerName: t("Montant ttc"),
      valueGetter: (params) =>
        params.row.total_ttc.toFixed(2) + ` ${organisation?.currency?.code}`,
    },
    {
      flex: 1,
      field: "Montant payé",
      headerName: t("Montant payé"),
      valueGetter: (params) =>
        params.row.status === 2
          ? Number(params.row.total_ttc).toFixed(2) +
            ` ${organisation?.currency?.code}`
          : Number(getMantantPaye(params.row.payment)).toFixed(2) +
            ` ${organisation?.currency?.code}`,
    },
    {
      flex: 1,
      field: "Reste à payé",
      headerName: t("Reste à payé"),
      valueGetter: (params) =>
        params.row.status === 2
          ? `0.00 ${organisation?.currency?.code}`
          : Number(params.row.invoice_rap).toFixed(2) +
            ` ${organisation?.currency?.code}`,
    },
    
    {
  flex: 1,
  field: "status",
  headerName: t("Status"),
  width: 100,
  disableClickEventBubbling: true,
  renderCell: (params) => {
    const onClickStatus = (e) => {
      $(".modal-backdrop").css({
        "background-color": "",
        display: "block",
      });

      setCurrentSelectedInvoice(params.row.id);
      setCurrentSelectedStatus(params.row.status_infos.id);
    };

    const payments = params.row.payment || [];
    const latestPayment = payments[payments.length - 1];

    return (
      <span
        className="badge rounded-pill bg-default badge-sm me-1 mb-1 mt-1"
        onClick={onClickStatus}
      >
        {latestPayment?.status?.name || "Pas encore payé"}
      </span>
    );
  },
},
    {
      flex: 1,
      field: "Dernier date de paiement",
      headerName: t("Dernier date de paiement"),
     
      valueGetter: (params) => {
  const payments = params.row.payment || [];
  const latestPayment = payments[payments.length - 1];

  if (!latestPayment?.status) {
    return "Pas encore payé";
  }

  if (latestPayment.status.id === 2) {
    return moment(latestPayment.created_at).format("DD/MM/YYYY");
  }

  if (latestPayment.status.id === 3) {
    return moment(latestPayment.updated_at).format("DD/MM/YYYY");
  }

  return "Pas encore payé";
},
    },
    {
      flex: 1,
      field: "Action",
      headerName: t("Action"),
      width: 180,
      sortable: false,
      disableClickEventBubbling: true,
    
      renderCell: (params) => {
  const onClickStatus = (e) => {
    $(".modal-backdrop").css({
      "background-color": "",
      display: "block",
    });
    setCurrentSelectedInvoice(params.row.id);
    setCurrentSelectedStatus(params.row.status_infos.id);
  };

  const payments = params.row.payment || [];
  const latestPayment = payments[payments.length - 1];

  return (
    <span
      className="badge rounded-pill bg-default badge-sm me-1 mb-1 mt-1"
      onClick={onClickStatus}
    >
      {latestPayment?.status?.name || "Pas encore payé"}
    </span>
  );
},
    },
  ];

  const print = async (data) => {
    const response = await jwtInterceoptor.get(
      `/data/user/factures/generate/${data.id}`,
      { responseType: "arraybuffer" }
    );
    if (response.status === 200) {
      const type = response.headers["content-type"];
      const blob = new Blob([response.data], { type: type, encoding: "UTF-8" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `FACT-${formatNumber(data.id)}`;
      link.click();
    }
  };

  const handleStatusChange = (e) => {
    setNewStatus(e.target.value);
  };

  const filter = async () => {
    await setInvoices(staticInvoices);

    let isOkToFilter =
      paymentType === "0" ||
      paymentType === "" ||
      selectedStatus === "0" ||
      selectedStatus === "" ||
      invoiceType === "0" ||
      invoiceType === "";

    if (selectedStatus !== "2")
      isOkToFilter =
        selectedStatus === "0" ||
        selectedStatus === "" ||
        invoiceType === "0" ||
        invoiceType === "";

    if (isOkToFilter) {
      let errorMessage =
        "L'état de la facture, le Mode de règlement et le Type de facture sont obligatoires";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      let res = staticInvoices.filter((invoice) => {
        // const lastPayment = invoice.payment[invoice.payment.length - 1];
        const lastPayment = invoice.payment?.[invoice.payment.length - 1];
        return (
          // (paymentType === "all" ||
          //   (paymentType == 6773 &&
          //     lastPayment.banquePaymentOption == null &&
          //     lastPayment.status != 1) ||
          //   (paymentType == 6768 && lastPayment.banquePaymentOption != null)) &&
          // // Condition sur le statut
          // (selectedStatus === "all" ||
          //   (Number(selectedStatus) === 2 && lastPayment.status.id == 2) ||
          //   (Number(selectedStatus) === 3 &&
          //     (lastPayment.status.id === 1 || lastPayment.status.id === 3))) &&
            (paymentType === "all" ||
    (paymentType == 6773 &&
      lastPayment?.banquePaymentOption == null &&
      lastPayment?.status != 1) ||
    (paymentType == 6768 &&
      lastPayment?.banquePaymentOption != null)) &&

  // Condition sur le statut
  (selectedStatus === "all" ||
    (Number(selectedStatus) === 2 &&
      lastPayment?.status?.id == 2) ||
    (Number(selectedStatus) === 3 &&
      (lastPayment?.status?.id === 1 ||
        lastPayment?.status?.id === 3))) &&
          (invoiceType === "all" || invoice.type === invoiceType)
        );
      });

      setInvoices(res);
      window.$("#staticBackdrop").modal("hide");
    }
  };
  const downloadEtatFac = async () => {
    if (!selectedRow || selectedRow.length === 0) {
      console.warn("Aucune facture sélectionnée");
      return;
    }

    const getMoyenPaiement = (facture) => {
      if (facture.payment && facture.payment.length > 0) {
        const paiement = facture.payment[facture.payment.length - 1];

        if (paiement.banquePaymentOption) return "Banque";
        if (paiement.chequeId) return "Chèque";
        if (paiement.effetId) return "Effet";
        if (paiement.payment_account) return "Caisse";

        return "Crée";
      }
      return "N/A";
    };
    // calcule montants

    // Nouvelle structure qui affiche les produits sur des lignes distinctes
    const donneesFormatees = [];
    let totalQte = 0;
    let totalPrixHT = 0;
    let totalPaiement = 0;

    // Parcourir chaque facture
    selectedRow.forEach((facture) => {
      // Récupérer le montant réellement payé (payed_amount)
      const montantPaye =
        facture.status == 2
          ? facture.total_ttc
          : facture.payment.reduce((acc, paiement) => {
              acc += Number(paiement.payed_amount);
              return acc;
            }, 0);
      // Ajouter au total des paiements seulement une fois par facture
      totalPaiement += montantPaye;
      console.log("montantPaye", montantPaye);
      // Si la facture a des produits (ce qui est toujours le cas d'après vos informations)
      const facturesProducts = facture.type == 'achat'? facture.product : facture.products;
      if (facturesProducts && facturesProducts.length > 0) {
        // Pour chaque produit de la facture
        facturesProducts.forEach((item, index) => {
          // Calculer les totaux
          const qte = Number(item.qty || 0);
          const prixUnitHT = Number(item.price_unit_ht || 0);
          const prixHT = Number(item.total_ht || 0);

          totalQte += qte;
          totalPrixHT += prixHT;

          // Ajouter une ligne pour ce produit
            if (facture.type === "vente") {
            donneesFormatees.push({
              date_facture: facture.created_at?.split("T")[0] || "N/A",
              date_echeance: facture.due_date?.split("T")[0] || "N/A",
              num_facture: facture.invoice_number || "N/A",
              num_pieces: facture.id || "N/A",
              compte_client: facture.client?.account || "N/A",
              nom_client: facture.client?.companyName || "N/A",
              ice_client: facture.client?.ice || "N/A",
              nom_article: item.product?.name || item.details || "N/A",
              val_pu_ht: prixUnitHT,
              val_qte: qte,
              val_pt_ht: prixHT,
              date_paiement:
              facture.payment && facture.payment.length > 0
                ? facture.payment[
                  facture.payment.length - 1
                ].created_at?.split("T")[0] || "N/A"
                : "N/A",
              val_paiement: montantPaye, // Afficher le paiement uniquement sur la première ligne
              mode_paiement: getMoyenPaiement(facture), // Afficher le mode de paiement uniquement sur la première ligne
            });
            } else if (facture.type === "achat") {
            donneesFormatees.push({
              date_facture: facture.created_at?.split("T")[0] || "N/A",
              date_echeance: facture.due_date?.split("T")[0] || "N/A",
              num_facture: facture.invoice_number || "N/A",
              num_pieces: facture.id || "N/A",
              compte_client: facture.client?.account || "N/A",
              nom_client: facture.client?.companyName || "N/A",
              ice_client: facture.client?.ice || "N/A",
              nom_article: item.product?.name || item.details || "N/A",
              val_pu_ht: prixUnitHT,
              val_qte: qte,
              val_pt_ht: prixHT,
              date_paiement:
              facture.payment && facture.payment.length > 0
                ? facture.payment[
                  facture.payment.length - 1
                ].created_at?.split("T")[0] || "N/A"
                : "N/A",
              val_paiement: montantPaye, // Afficher le paiement uniquement sur la première ligne
              mode_paiement: getMoyenPaiement(facture), // Afficher le mode de paiement uniquement sur la première ligne
            });
            }
        });
      }else if(facture.accounts && facture.accounts.length > 0) {
        // Pour chaque produit de la facture
        facture.accounts.forEach((item, index) => {
          // Calculer les totaux
          const qte = Number(item.qty || 1);
          const prixUnitHT = Number(item.total_ht || 0);
          const prixHT = Number(item.total_ht || 0);
          
          totalQte += qte;
          totalPrixHT += prixHT;
          
          // Ajouter une ligne pour ce produit
          donneesFormatees.push({
            date_facture: facture.created_at?.split("T")[0] || "N/A",
            date_echeance: facture.due_date?.split("T")[0] || "N/A",
            num_facture: facture.invoice_number || "N/A",
            num_pieces: facture.id || "N/A",
            compte_client: facture.client?.account || "N/A",
            nom_client: facture.client?.companyName || "N/A",
            ice_client: facture.client?.ice || "N/A",
            nom_article: item.designation || item.details || "N/A",
            val_pu_ht: prixUnitHT,
            val_qte: qte,
            val_pt_ht: prixHT,
            date_paiement: facture.payment && facture.payment.length > 0 ? 
                           facture.payment[facture.payment.length-1].created_at?.split("T")[0] || "N/A" : "N/A",
            val_paiement:  montantPaye , // Afficher le paiement uniquement sur la première ligne
            mode_paiement:  getMoyenPaiement(facture) // Afficher le mode de paiement uniquement sur la première ligne
          });
        });
      } 
    });

    // Ajouter une ligne de total avec la nouvelle structure
    donneesFormatees.push({
      date_facture: "",
      date_echeance: "",
      num_facture: "",
      num_pieces: "",
      compte_client: "",
      nom_client: "",
      ice_client: "",
      nom_article: "TOTAL",
      val_pu_ht: "",
      val_qte: totalQte.toFixed(2),
      val_pt_ht: totalPrixHT.toFixed(2),
      date_paiement: "",
      val_paiement: totalPaiement.toFixed(2),
      mode_paiement: "",
    });

    const { value: fileType } = await Swal.fire({
      title: "Choisissez le format de téléchargement",
      input: "radio",
      inputOptions: {
        csv: "CSV",
        pdf: "PDF",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Vous devez choisir une option!";
        }
      },
      showCancelButton: true,
      confirmButtonText: "Télécharger",
      cancelButtonText: "Annuler",
    });

    if (fileType === "csv") {
      const csv = Papa.unparse(donneesFormatees, { delimiter: ";" });
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "etat_factures.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (fileType === "pdf") {
      const { jsPDF } = await import("jspdf");
      const autoTable = (await import("jspdf-autotable")).default;

      const doc = new jsPDF({ orientation: "landscape" });
      const headerHeight = 30;
      const logoWidth = 30;
      const logoHeight = 15;
      const organisationName = organisation?.name || "Nom de l'organisation";
      const tirageDate = `Date de tirage : ${moment().format(
        "DD/MM/YYYY à HH:mm"
      )}`;
      doc.setFontSize(10);
      doc.text(organisationName, 10, 15);
      try {
        const logoX = (doc.internal.pageSize.width - logoWidth) / 2; // Centrer horizontalement
        doc.addImage(logo, "PNG", logoX, 5, logoWidth, logoHeight); // Position : centré, 5 (y)
      } catch (error) {
        console.error("Erreur lors de l'ajout du logo :", error);
      }

      // Ajouter le titre sous le logo
      doc.setFontSize(12);
      doc.text("État de Trésorerie", doc.internal.pageSize.width / 2, 25, {
        align: "center",
      }); // Centré horizontalement

      // Ajouter la date de tirage à droite
      doc.setFontSize(10);
      const tirageX = doc.internal.pageSize.width - 10; // Aligné à droite
      doc.text(tirageDate, tirageX, 15, { align: "right" });

      // Ajouter une ligne pour séparer l'en-tête
      doc.line(
        10,
        headerHeight,
        doc.internal.pageSize.width - 10,
        headerHeight
      );

      // Définir les colonnes avec les mêmes noms que dans le CSV
      const columns = [
        "Date Facture",
        "Date Échéance",
        "Numéro Facture",
        "N° Pièce",
        "Compte Client",
        "Nom Client",
        "ICE Client",
        "Nom Article",
        "PU HT",
        "Qté",
        "PT HT",
        "Date Paiement",
        "Montant Payé",
        "Mode Paiement",
      ];

      // Transformer les données pour le PDF en utilisant les mêmes champs que le CSV
      const rows = donneesFormatees.map((facture) => [
        facture.date_facture,
        facture.date_echeance,
        facture.num_facture,
        facture.num_pieces,
        facture.compte_client,
        facture.nom_client,
        facture.ice_client,
        facture.nom_article,
        typeof facture.val_pu_ht === "number"
          ? facture.val_pu_ht.toFixed(2)
          : facture.val_pu_ht,
        facture.val_qte,
        typeof facture.val_pt_ht === "number"
          ? facture.val_pt_ht.toFixed(2)
          : facture.val_pt_ht,
        facture.date_paiement,
        typeof facture.val_paiement === "number"
          ? facture.val_paiement.toFixed(2)
          : facture.val_paiement,
        facture.mode_paiement,
      ]);

      // Appliquer des styles spécifiques pour la ligne de total
      const rowStyles = rows.map((_, index) =>
        index === rows.length - 1
          ? { fontStyle: "bold", fillColor: [240, 240, 240] }
          : {}
      );

      // Générer le tableau avec l'en-tête
      autoTable(doc, {
        head: [columns],
        body: rows,
        startY: headerHeight + 10,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [61, 49, 155] }, // Couleur de l'en-tête
        rowStyles: rowStyles, // Appliquer les styles pour chaque ligne
      });

      // Télécharger le PDF
      doc.save("etat_trésorie.pdf");
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="row" style={{ zIndex: 1 }}>
        <div
          class="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">
                  {t("Filtrer votre trésorerie")}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div
                  class="alert alert-danger alert-dismissible fade show mb-0 some-fields-are-required-to-save"
                  role="alert"
                >
                  <span class="alert-inner--icon">
                    <i class="fe fe-slash"></i>
                  </span>
                  <span class="alert-inner--text">
                    <strong></strong>Attention ! Les champs suivants sont
                    obligatoire.
                  </span>
                  <p>
                    - L'état de la factrue <br />
                    - Mode de réglement <br />
                    - Type de facture <br />
                  </p>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="">
                    {t("Type de facture")}*
                  </label>
                  <select
                    className="form-select"
                    id="buyPriceAccountInput"
                    onChange={(e) => setInvoiceType(e.target.value)}
                    value={invoiceType}
                  >
                    <option value="0">selectionner un type de facture</option>
                    <option value="achat">Facture d'achat</option>
                    <option value="depense">Facture de depense</option>
                    <option value="vente">Facture de vente</option>
                    <option value="all">Tous</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="">
                    {t("Mode de règlement")}*
                  </label>
                  <select
                    className="form-select"
                    id="buyPriceAccountInput"
                    onChange={(e) => {
                      setPaymentType(e.target.value);
                      console.log(e.target.value);
                    }}
                    value={paymentType}
                  >
                    <option value="0">selectionner un mode de réglement</option>
                    <option value={bqAccountId}>
                      Banques (soldes débiteurs)
                    </option>
                    <option value={caisseAccountId}>Caisses</option>
                    <option value="all">les Deux</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="">
                    {t("Etat")}*
                  </label>
                  <select
                    className="form-select"
                    id="buyPriceAccountInput"
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    value={selectedStatus}
                  >
                    <option value="0">
                      selectionner l'état des factures à afficher
                    </option>
                    <option value="2">Payé</option>
                    <option value="3">Non Payé</option>
                    <option value="all">les Deux</option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setInvoices(staticInvoices);
                    window.$("#staticBackdrop").modal("hide");
                  }}
                >
                  {t("Afficher tout")}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => filter()}
                >
                  {t("Enregistrer")}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-12">
          <div class="page-header">
            <h1 class="page-title breadcumpsHeader">{t("Trésorerie")}</h1>
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  {t("Trésorerie")}
                </li>
              </ol>
            </div>
          </div>

          <div className="card">
            <div class="mt-4 mb-4 mx-4 text-right">
              <a
                className="btn btn-primary"
                onClick={() => {
                  window.$("#staticBackdrop").modal("show");
                }}
              >
                {t("Filtrer à nouveaux")}
              </a>
            </div>
            {/* adding filtre de date */}
            <div className="mb-4 text-right d-flex ">
              <div className="col-3 mx-4">
                <label htmlFor="dateDebut">{t("Date de début")}:</label>
                <input
                  type="date"
                  className="form-control"
                  id="dateDebut"
                  value={dateDebut}
                  onChange={(e) => setDateDebut(e.target.value)}
                />
              </div>
              <div className="col-3 mx-4">
                <label htmlFor="dateFin">{t("Date de fin")}:</label>
                <input
                  type="date"
                  className="form-control"
                  id="dateFin"
                  value={dateFin}
                  onChange={(e) => setDateFin(e.target.value)}
                />
              </div>
              <div className="col-4 ">
                <button
                  className="btn btn-primary mx-4 mt-5"
                  onClick={handleFilterDate}
                >
                  {t("Filter par date")}
                </button>
                {filteredInvoices.length !== 0 ? (
                  <button
                    className="btn btn-danger mt-5"
                    onClick={() => {
                      setFilteredInvoices([]);
                    }}
                  >
                    {t("Afficher tout")}
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div style={{ height: 600, width: "100%" }}>
                  <DataGrid
                    rows={filteredInvoices.length ? filteredInvoices : invoices}
                    columns={columns}
                    pagination={false}
                    localeText={
                      i18n.language == "fr"
                        ? frFR.components.MuiDataGrid.defaultProps.localeText
                        : enUS.components.MuiDataGrid.defaultProps.localeText
                    }
                    getRowId={(row) => `${row.type}-${row.id}`}
                    slots={{
                      toolbar: GridToolbar,
                      loadingOverlay: LinearProgress,
                    }}
                    slotProps={{
                      toolbar: {
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },
                      },
                    }}
                    loading={loadingData}
                    checkboxSelection
                    columnVisibilityModel={
                      visibleColumns ? visibleColumns : columns
                    }
                    onColumnVisibilityModelChange={
                      handleColumnVisibilityModelChange
                    }
                    onRowSelectionModelChange={(ids) => {
                      console.log("ids", ids);
                      const selectedIDs = new Set(ids);
                      const selectedRowData = invoices.filter((row) =>
                        selectedIDs.has(`${row.type}-${row.id}`)
                      );
                      setSelectedRow(selectedRowData);
                      console.log(selectedRowData);
                      let totalAmount = selectedRowData.reduce(
                        (accumulator, inv) => {
                          return accumulator + inv.total_ttc;
                        },
                        0
                      );
                      // Calculez le reste à payer
                      const restPaye = selectedRowData.reduce(
                        (accumulatorRest, invRes) => {
                          if (invRes.status !== 2) {
                            return accumulatorRest + invRes.invoice_rap;
                          } else {
                            return accumulatorRest + 0;
                          }
                        },
                        0
                      );
                      // Mettez à jour les états
                      setTotalRestPaye(restPaye);
                      setGrandTotal(totalAmount);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card-footer">
              <div className="row">
                <div className="col">
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadEtatFac()}
                  >
                    Télécharger etat de Trésorerie
                  </button>
                </div>
                <div className="col text-right">
                  {grandTotal ? (
                    <div className="d-flex flex-row-reverse">
                      <span
                        className="text-success"
                        style={{
                          fontSize: 19,
                          fontWeight: "bold",
                        }}
                      >
                        {t("Total général")} {Number(grandTotal).toFixed(2)}{" "}
                        {organisation?.currency?.code} TTC
                      </span>
                      <span
                        className="text-danger"
                        style={{
                          fontSize: 19,
                          fontWeight: "bold",
                          marginRight: 70,
                        }}
                      >
                        {t("Total reste a payé")}{" "}
                        {Number(totalRestPaye).toFixed(2)}{" "}
                        {totalRestPaye?.currency?.code} TTC
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Tresorie;
